import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';
import { useUserInformation } from '@hooks/useUserInformation';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useAuthRedirect } from '@services/Auth/useAuthRedirect';
import { useAppointmentId } from '@store/appointment/selectors';
import { useUserRole } from '@utils/useUserRole';

const Landing = () => {
  const navigate = useNavigate();

  useAuthRedirect();

  const profile = useUserInformation();
  const { basketId } = useBasketContext();
  const appointmentId = useAppointmentId();

  const { isPartner, loading } = useUserRole();

  useEffect(() => {
    if (loading) return;

    if (isPartner) {
      if (basketId) {
        navigate(paths.bundle);
      } else if (appointmentId) {
        navigate(paths.address);
      } else {
        navigate(paths.partner);
      }
    } else {
      navigate(paths.address);
    }
  }, [basketId, navigate, isPartner, profile, loading, appointmentId]);

  return null;
};

export { Landing };
